exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invalid[data-v-6e26b58a]{border:1px solid red!important;box-shadow:0 0 5px red!important;background-color:#fff238!important}.selRow[data-v-6e26b58a]{color:#7e489c;background-color:#fbff94}.selRow td[data-v-6e26b58a]{background:none}.selRow .text-info[data-v-6e26b58a],.text-primary[data-v-6e26b58a]{color:#7e489c!important}.selShow[data-v-6e26b58a]{color:#17a2b8;background-color:#fff}.rowBoxShadow[data-v-6e26b58a]{box-shadow:0 -2px 3px rgb(126 72 156/15%)}.rowCursorPointer[data-v-6e26b58a]{cursor:pointer}.tdGradient[data-v-6e26b58a]{background:linear-gradient(hsla(0,0%,91%,.4),#fff)}.tdGradient2[data-v-6e26b58a]{background:linear-gradient(hsla(0,0%,91%,.4),#fff,#fff)}.shortText[data-v-6e26b58a]{padding:0 5px!important;max-width:200px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e26b58a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/NewAccDoc/NewAccDoc.vue
// module id = 480
// module chunks = 0